export default __webpack_public_path__ + "static/media/IconDesc_Balls.256.8413b0bc.png";